/**
 * CWR 2.4 — fixed bottom action bar (mockup .sd-bottombar): price block + an
 * optional payment-terms line (icon + copy from the shared formatter) + the
 * primary CTA (label + optional sub-line) + an inline error line on failure.
 */
import styles from '../SessionDetailPage.module.css';
import { PaymentIcon } from '../detailIcons';

export interface DetailStickyBarProps {
  priceMain: string;
  /** Payment-terms line from `paymentTermsText`; null/undefined → no line. */
  terms?: string | null;
  ctaLabel: string;
  ctaSub?: string;
  onCta: () => void;
  disabled?: boolean;
  error?: string | null;
}

export function DetailStickyBar({
  priceMain,
  terms,
  ctaLabel,
  ctaSub,
  onCta,
  disabled,
  error,
}: DetailStickyBarProps) {
  return (
    <div className={styles.bottombar} data-testid="detail-sticky-bar">
      <div className={styles.priceBlock}>
        <div className={styles.p1}>{priceMain}</div>
        {terms && (
          <span className={styles.terms} data-testid="payment-terms">
            <span className={styles.payIco}>{PaymentIcon}</span>
            {terms}
          </span>
        )}
      </div>
      <button
        type="button"
        data-testid="book-cta"
        className={styles.bookBtn}
        onClick={onCta}
        disabled={disabled}
      >
        {ctaLabel}
        {ctaSub && <small>{ctaSub}</small>}
      </button>
      {error && (
        <div className={styles.bookError} role="alert">
          {error}
        </div>
      )}
    </div>
  );
}
